import { render, staticRenderFns } from "./HomeIcon.vue?vue&type=template&id=af33874c&scoped=true"
import script from "./HomeIcon.vue?vue&type=script&lang=js"
export * from "./HomeIcon.vue?vue&type=script&lang=js"
import style0 from "./HomeIcon.vue?vue&type=style&index=0&id=af33874c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af33874c",
  null
  
)

export default component.exports